require('./cardDetailsSidebar.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const trim = require('lodash/string/trim');
const isEmpty = require('lodash/lang/isEmpty');
const reject = require('lodash/collection/reject');

// @core
const { formatText, hasTranslation, getLanguage } = require('core/i18n').i18n;

// @utilities
const { getFormattedString, formatAmountObject } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
const { formatCardNumber } = require('utilities/cardsHelper');

// @components
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKAsyncInformativeListItem = require('components/contactCenter/OKAsyncInformativeListItem/OKAsyncInformativeListItem');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')

const { COUNTRIES_CODES: { ES, GB, PT, NL, DE } } = require('constants/countries');
// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @constants
const {
    CARD_DEBIT,
    CARD_CREDIT,
    DATE_FORMAT_SHORT_MONTH_SHORT_YEAR,
    CARD_ECARD,
    CARD_INTERVENTION_OWNER,
    EMPTY_CONCEPT,
    NO_RENOVAR,
    FIRST_STEP,
    EURO_TEXT,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
} = require('constants/index');

const DETAILS_VIEW_MINICARD = ['fullNumber', 'expirationDate', 'status'];
const DETAILS_VIEW_DEBIT = ['fullNumber', 'expirationDate', 'status'];
const DETAILS_VIEW_CREDIT = ['fullNumber', 'expirationDate', 'status'];
const DETAILS_VIEW_ECARD = ['fullNumber', 'expirationDate', 'status'];
const DETAILS_VIEW_ECARD_PDF = ['fullNumberAndEcardPdf', 'expirationDate', 'status'];
const DETAILS_VIEW_OPENYOUNG = ['fullNumber', 'expirationDate', 'status'];
const OTHER_VIEW_ORDER = ['number', 'status', 'type'];
const { INACTIVE_STATUS_LIST, CANCELLED_STATUS } = require('constants/contactCenter/cardStatus');
const { getTranslatedRoad, TYPEOFROADS } = require('constants/typeOfRoads');


class CardDetailsSideBar extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        // Be careful!! When we bind a function with "this", it changes, so we
        // need to declare the binding to a function in order to being able to
        // remove the lister from window.

        this.resize = this.resize.bind(this);

        this.state = {
            parentWidth: window.innerWidth
        };
    }



    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    getCardFieldsToShow(immCard) {
        const { immCardSecurePayment, flagBasedFeatures } = this.props;
        const CURRENT_URL = window.location.pathname;
        const DETAILS_URL = `/myprofile/cards/${immCard.get('cardId')}/details`;
        const SECURE_PAYMENT_URL = `/myprofile/cards/${immCard.get('cardId')}/secure-payment`;
        const cardType = immCard.get('type');
        const output = [];
        const isOpenYoung = immCard.get('isOpenYoung');
        const interventionType = immCard.get('interventionType');
        const isCESCurrentStateFetched = immCardSecurePayment && immCardSecurePayment.get('fetchSuccessful');
        const statusCard = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');
        let orderArray;

        if (CURRENT_URL === DETAILS_URL) {
            switch (cardType) {
                case CARD_DEBIT:
                    orderArray = immCard.get('isMinicard') ? [...DETAILS_VIEW_MINICARD] : [...DETAILS_VIEW_DEBIT];
                    break;
                case CARD_CREDIT:
                    orderArray = [...DETAILS_VIEW_CREDIT];
                    break;
                case CARD_ECARD:
                    if (isOpenYoung) {
                        orderArray = [...DETAILS_VIEW_OPENYOUNG];
                    } else {
                        if (cardValidationRules.CARD_DOWNLOAD_PDF.validator({ immCard })) {
                            orderArray = [...DETAILS_VIEW_ECARD_PDF];
                        } else {
                            orderArray = [...DETAILS_VIEW_ECARD];
                        }
                    }
                    break;
            }

            if (!__CONTACT_CENTER__ && cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard })) {
                orderArray.push('pin');
            }

            if (!__CONTACT_CENTER__ && cardValidationRules.CARD_PIN_CVV_REQUEST.validator({ immCard, isCVVRequest: true })) {
                orderArray.push('cvv');
            }

            if (isCESCurrentStateFetched && cardValidationRules.CARD_SECURE_PAYMENT.validator({ immCard })) {
                orderArray.push('CESCurrentState');
            }

            if (__CONTACT_CENTER__ && (cardType === CARD_CREDIT || cardType === CARD_DEBIT) && !INACTIVE_STATUS_LIST.includes(statusCard)) {
                orderArray.push('renewalStatus');
            }
        } else {
            const NEW_OTHER_VIEW_ORDER = [
                'number',
                'status',
                'type',
                'methodOfPaymentDeferredFixedFee',
                'paymentMethodAmount',
                ...(this.props.currentInstallments ? ['paymentMethod'] : []),
                ...(this.props.currentMethod !== CARD_PAYMENT_METHOD_UNIQUE ? ['tin'] : []),
                ...(this.props.currentMethod !== CARD_PAYMENT_METHOD_UNIQUE ? ['tae'] : []),

            ];
            orderArray = this.props.newCreditCardsMethodFF ? [...NEW_OTHER_VIEW_ORDER] : [...OTHER_VIEW_ORDER];

            if ((cardType === CARD_CREDIT || isOpenYoung) &&
                immCard.get('hasBeneficiaries') &&
                interventionType !== CARD_INTERVENTION_OWNER) {
                orderArray.push('beneficiaryName');
            }

            if (CURRENT_URL === SECURE_PAYMENT_URL) {
                if (isCESCurrentStateFetched) {
                    orderArray.push('CESCurrentState');
                }
                orderArray.push('phoneNumber');
            }

            if (
                __CONTACT_CENTER__ &&
                flagBasedFeatures &&
                immCard.get('isConfigurable') &&
                immCard.get('active') &&
                immCard.get('isOperative') &&
                flagBasedFeatures.get('card-control-enabled')
            ) {
                orderArray.push('updateHistory');
            }
        }

        //(nicolas.olmos): insert values in the desired order on the output array.
        orderArray.forEach(key => {
            output.push(this.getField(immCard, key));
        });
        return output;
    }

    getField(immCard, key) {
        let field;
        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardSidebar-methodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardSidebar-methodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardSidebar-methodOfPaymentDeferredVariableFee')}`
        };
        switch (key) {
            case 'number':
                const cardNumber = immCard.get('number');
                const cardNumberLastNumbers = formatCardNumber(cardNumber, 4, '*');

                field = {
                    name: 'cards-cardNumber',
                    value: `${cardNumberLastNumbers}`
                };
                break;
            case 'cardNumber':
                field = {
                    name: 'cardDetailsSideBar-cardNumber',
                    value: immCard.get('number')
                };
                break;
            case 'fullNumberAndEcardPdf':
                field = {
                    name: 'cards-cardNumber',
                    value: immCard.get('number'),
                    link: {
                        url: `/myprofile/cards/${immCard.get('cardId')}/download-pdf`,
                        text: formatText('cardDetailsSideBar-ecardPdf')
                    }
                };
                break;
            case 'expirationDate':
                field = {
                    name: 'cardDetailsSideBar-expiration',
                    value: DateHelper.formatDate(
                        immCard.get('expirationDate'),
                        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR
                    )
                };
                break;
            case 'status':
                field = {
                    name: 'cards-status',
                    value: formatText(`card-status${immCard.get('status')}`)
                };
                break;
            case 'pin':
                field = {
                    name: 'cardDetailsSideBar-pin',
                    link: {
                        url: `/myprofile/cards/${immCard.get('cardId')}/request/pin`,
                        text: formatText('cardDetailsSideBar-consult')
                    },
                    tooltipContent: formatText('cardDetailsSideBar-pinTooltipMessage')
                };

                if (cardValidationRules.CARD_PIN_CHANGE.validator({ immCard })) {
                    field.secondaryLink = {
                        url: `/myprofile/cards/${immCard.get('cardId')}/pin-change`,
                        text: formatText('cardDetailsSideBar-change')
                    };
                }
                break;
            case 'cvv':
                field = {
                    name: 'cardDetailsSideBar-cvv',
                    link: {
                        url: `/myprofile/cards/${immCard.get('cardId')}/request/cvv`,
                        text: formatText('cardDetailsSideBar-consult')
                    },
                    tooltipContent: formatText('cardDetailsSideBar-cvvTooltipMessage')
                };
                break;
            case 'type':
                field = {
                    name: 'cardActivate-cardType',
                    value: immCard.get('isViaT') ? 'cards-viaT' : `cards-${immCard.get('type')}`
                };
                break;
            case 'beneficiaryName':
                field = {
                    name: 'cardActivate-cardBeneficiary',
                    value: immCard.get('beneficiaryName')
                };
                break;
            case 'creditLimit':
                field = {
                    name: 'cardActivate-cardCreditLimit',
                    value: getFormattedString({
                        amount: immCard.getIn(['limit', 'amount']),
                        currency: immCard.getIn(['limit', 'currency']),
                        decimalsLength: 0
                    })
                };
                break;
            case 'CESCurrentState':
                const immCardSecurePayment = this.props.immCardSecurePayment;
                const isSecureCommerceChecked = immCardSecurePayment.getIn(['steps', FIRST_STEP, 'isSecureCommerceCheckedLast']);
                const isNoSecureCommerceChecked = immCardSecurePayment.getIn(['steps', FIRST_STEP, 'isNoSecureCommerceCheckedLast']);
                const CURRENT_URL = window.location.pathname;
                const DETAILS_URL = `/myprofile/cards/${immCard.get('cardId')}/details`;
                let CESText;

                if (isSecureCommerceChecked && isNoSecureCommerceChecked) {
                    CESText = 'cardDetailsSideBar-withAndwithoutCES';
                } else if (isSecureCommerceChecked && !isNoSecureCommerceChecked) {
                    CESText = 'cardDetailsSideBar-commercesAdheredToCES';
                } else if (!isSecureCommerceChecked && isNoSecureCommerceChecked) {
                    CESText = 'cardDetailsSideBar-commercesNotAdheredToCES';
                } else {
                    CESText = 'cardDetailsSideBar-withoutCESregistry';
                }

                field = {
                    name: 'cardDetailsSideBar-CESCurrentState',
                    [this.state.parentWidth > 1024 ? 'value' : 'tooltipContent']: formatText(CESText)
                };

                if (CURRENT_URL === DETAILS_URL) {
                    field.link = {
                        url: `/myprofile/cards/${immCard.get('cardId')}/secure-payment`,
                        text: formatText('cardDetailsSideBar-change')
                    };
                }

                break;
            case 'phoneNumber':
                field = {
                    name: 'cardDetailsSideBar-phoneNumber',
                    value: this.props.phoneNumber
                };
                break;
            case 'fullNumber':
                field = {
                    name: 'cards-cardNumber',
                    value: immCard.get('number')
                };
                break;

            case 'renewalStatus':
                const cardStatus = this.props.immCardRenewalStatus.getIn(['cancelRenewalDetails', 'descripcionSituaTarjeta']);
                const noRenewal = (cardStatus ? cardStatus.toUpperCase() === NO_RENOVAR : cardStatus);

                field = {
                    name: 'creditRenewal-statusLabel',
                    value: noRenewal ? 'creditRenewal-statusNoRenewalValue' : 'creditRenewal-statusRenewalValue',
                    link: {
                        url: `/myprofile/cards/${immCard.get('cardId')}/cancel-renewal`,
                        text: noRenewal ? formatText('creditRenewal-activateRenewalLink') : formatText('creditRenewal-statusLink')
                    },
                    isAsync: true,
                    isLoading: this.props.immCardRenewalStatus.get('fetchingRenewalDetails'),
                    isError: this.props.immCardRenewalStatus.get('errorGettingRenewalDetails')
                };
                break;
            case 'updateHistory':
                field = {
                    link: {
                        url: `/myprofile/cards/config/${immCard.get('cardId')}/history`,
                        text: formatText('cardDetailsSideBar-updateHistory')
                    }
                };
                break;
            case 'methodOfPaymentDeferredFixedFee':
                field = {
                    name: 'cardDetailsSidebar-cardDetailsSidebar_methodOfPaymentDeferredFixedFee',
                    value: paymentMethod[this.props.method]
                };
                break;
            case 'paymentMethodAmount':
                field = {
                    name: 'cardDetailsSidebar-cardDetailsSidebar_paymentMethodAmount',
                    value: paymentMethod[this.props.currentMethod]
                };
                break;
            case 'paymentMethod':
                field = {
                    name: this.props.newCreditCardsMethodFF ? 'cardChangePaymentMethod-newInstallmenAmount' : 'hireCardSidebar-paymentMethodAmount',
                    value: <OneLineSymbolAmount
                        amountObject={{
                            amount: this.props.installmenAmount,
                            currency: EURO_TEXT
                        }}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject({
                            amount: this.props.installmenAmount,
                            currency: EURO_TEXT
                        }, true)}
                    />
                };
                break;
            case 'tin':
                field = {
                    name: 'hireCardSidebar-tin',
                    value: this.props.tin
                };
                break;
            case 'tae':
                field = {
                    name: 'hireCardSidebar-tae',
                    value: this.props.tae
                };
                break;
        }

        return field;
    }

    getATMLanguage(language = EMPTY_CONCEPT) {
        const languageTrim = language.trim();
        const proxyLanguages = {
            'ALEMAN': DE,
            'ESPAÑOL': ES,
            'HOLANDES': NL,
            'PORTUGUES': PT,
            'INGLES': GB
        };

        return proxyLanguages[languageTrim]
            ? (hasTranslation(`language-${proxyLanguages[languageTrim]}`)
                ? formatText(`language-${proxyLanguages[languageTrim]}`)
                : languageTrim)
            : languageTrim;
    }

    buildInformativeListItems(fields) {
        return fields.map(item => {
            let link;
            let secondaryLink;

            if (item.link) {
                link = (
                    <OKLink modifier="emphasize" to={item.link.url}>
                        {item.link.text}
                    </OKLink>
                );
            }

            if (item.secondaryLink) {
                secondaryLink = (
                    <OKLink modifier="emphasize" to={item.secondaryLink.url}>
                        <span className="card-details-side-bar__secondary-link-separator">|</span>
                        {item.secondaryLink.text}
                    </OKLink>
                );
            }

            if (item.tooltipContent) {
                return (
                    <OKInformativeListItem
                        key={item.name}
                        title={item.name}
                        bodyText={item.value}
                        icon="icon-informacion"
                        tooltipPlacement="top"
                        tooltipOffset={[0, -15]}
                        information={item.tooltipContent}
                    >
                        {link}
                        {secondaryLink}
                    </OKInformativeListItem>
                );
            } else if (__CONTACT_CENTER__ && item.isAsync) {
                return (
                    <OKAsyncInformativeListItem key={item.name} title={item.name} bodyText={item.value} isLoading={item.isLoading} isError={item.isError}>
                        {link}
                        {secondaryLink}
                    </OKAsyncInformativeListItem>
                );
            } else {
                return (
                    <OKInformativeListItem key={item.name} title={item.name} bodyText={item.value}>
                        {link}
                        {secondaryLink}
                    </OKInformativeListItem>
                );
            }
        });
    }

    buildCCPrintedListItems() {
        const { immCard, immCardData, immLatestCardHistory } = this.props;
        if (!__CONTACT_CENTER__ || !immCardData || !immLatestCardHistory) return null;

        const { textoRelieve, textoOpcional, idiomaContrato } = immCardData.get('cardData').toJS();
        const {
            tipoVia, nombreVia, numeroVia, restoDatosDomicilio, descripcionPlaza, codigoPostal
        } = immLatestCardHistory.get('domicilio').toJS();
        const formattedTipoVia = (TYPEOFROADS.includes(tipoVia)) ? getTranslatedRoad(tipoVia) : null;
        const formattedCodigoPostal = codigoPostal ? `(${codigoPostal.trim()})` : null;
        const notAvailable = formatText('commons-NA');

        const isViaT = immCard.get('isViaT');
        const isECard = immCard.get('type') === CARD_ECARD;

        const highlightedText = (isViaT || isECard) ? notAvailable
            : immCard.get('beneficiaryNameOnCard') || textoRelieve;
        const optionalText = (isViaT || isECard) ? notAvailable : textoOpcional;
        const language = (isViaT || isECard) ? notAvailable : this.getATMLanguage(idiomaContrato);
        const address = reject([
            formattedTipoVia,
            nombreVia,
            numeroVia,
            restoDatosDomicilio,
            descripcionPlaza,
            formattedCodigoPostal
        ].map(trim), isEmpty).join(' ').toUpperCase();

        const isFetchingCardData = immCardData.get('isFetching');
        const isErrorCardData = !!immCardData.get('error');

        return [
            {
                title: formatText('cardPrintedInformation-highlightedText'),
                bodyText: highlightedText || EMPTY_CONCEPT,
            },
            {
                title: formatText('cardPrintedInformation-optionalText'),
                bodyText: optionalText || EMPTY_CONCEPT,
                isLoading: isFetchingCardData,
                isError: isErrorCardData,
            },
            {
                title: formatText('cardPrintedInformation-address'),
                bodyText: address || EMPTY_CONCEPT,
                isLoading: isFetchingCardData,
                isError: isErrorCardData,
            },
            {
                title: formatText('cardPrintedInformation-language'),
                bodyText: language || EMPTY_CONCEPT,
                isLoading: isFetchingCardData,
                isError: isErrorCardData,
            },
        ].map((item, i) => <OKAsyncInformativeListItem key={i} {...item} />);
    }

    resize() {
        this.setState({
            parentWidth: window.innerWidth
        });
    }
    render() {
        const { immCard } = this.props;
        const cardFields = this.getCardFieldsToShow(immCard);
        const informativeListItems = this.buildInformativeListItems(cardFields);

        return (
            <OKSectionBox className="card-details-side-bar">
                <CommercialAds path="cards" type="cards" immCard={immCard} />
                <div className="card-details-side-bar__list">
                    <OKInformativeList columns={this.state.parentWidth > 1024 ? 1 : 3}>
                        {informativeListItems}
                        <ContactCenterRender>
                            {this.buildCCPrintedListItems()}
                        </ContactCenterRender>
                    </OKInformativeList>
                </div>
            </OKSectionBox>
        );
    }
}

CardDetailsSideBar.propTypes = {
    flagBasedFeatures: PropTypes.object,
    immCard: PropTypes.object.isRequired,
    immCardSecurePayment: PropTypes.object,
    immCardData: PropTypes.object,
    immLatestCardHistory: PropTypes.object,
    immCardRenewalStatus: PropTypes.object,
    phoneNumber: PropTypes.string
};

module.exports = CardDetailsSideBar;
